import { render, staticRenderFns } from "./work-order-tasks.html?vue&type=template&id=a5b4483e&scoped=true&"
import script from "./work-order-tasks.ts?vue&type=script&lang=js&"
export * from "./work-order-tasks.ts?vue&type=script&lang=js&"
import style0 from "./WorkOrderTasks.vue?vue&type=style&index=0&id=a5b4483e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4483e",
  null
  
)

export default component.exports